// extracted by mini-css-extract-plugin
export var dropdown = "_vo-0";
export var imageWrapper = "_vo-3";
export var itemNameContainer = "_vo-1";
export var productImage = "_vo-2";
export var spinnerWrapper = "_vo-4";